import { useMemo } from 'react'
import useAxios from 'axios-hooks'

const namespace = 'scholarships-stage'

export const useTransitionStatus = (body) => {
  const [{ data, loading, error }, reFetch] = useAxios({
    method: 'PATCH',
    url: `${namespace}/transition-status`,
    data: body,
  }, { manual: true })

  return useMemo(() => ({ data, loading, error, reFetch }), [
    data,
    loading,
    error,
    reFetch,
  ])
}
